<template>
    <div id="BioToolsLayout">
        <Header></Header>
        <!-- * 收藏  -->
        <div class="container relative" v-if="favorite">
            <div class="absolute top-[40px] right-0 z-[6]">
                <Favorites />
            </div>
        </div>
        <div id="BioToolsLayoutContainer">
            <slot></slot>
        </div>

        <Footer :top="200"></Footer>
    </div>
</template>
<script lang="ts" setup>
//* 公共组件
import { Header, Footer } from "@/components/complete";
import { Favorites } from "@/components/controls";
//* 组件属性注册
defineProps({
    favorite: { type: Boolean, default: false },
});
onMounted(() => {
    document.body.classList.add("root1328");
});

onBeforeUnmount(() => {
    document.body.classList.remove("root1328");
});
</script>

<style lang="less">
.ui-full-loading {
    height: 100vh;
    font-size: 64px;
}
</style>

<style lang="less" scoped>
#Header {
    box-shadow: var(--ui-boxsha);
}

#BioToolsLayout {
    margin: 0 auto;
    display: flex;
    max-width: 2560px;
    min-height: 100vh;
    flex-direction: column;

    #BioToolsLayoutContainer {
        flex: 1;
    }
}

// 输入页面
:deep(.bio-tools-model) {
    position: relative;
    margin: 76px auto 0;
    color: var(--uicolor-font-2);
    line-height: 22px;

    .title {
        margin: 0 0 76px;
        font-size: 32px;
        text-align: center;
        line-height: 40px;
        color: var(--uicolor-font-1);
    }

    .bg {
        background: var(--ui-color-2);
    }
}

// 复选框 改 单选选择框
:deep(.ui-checkbox-radio) {
    &.ui-active {
        > .ui-checkbox-control {
            background-color: transparent;

            &:after {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 70%;
                height: 70%;
                content: "";
                background-color: var(--uioption-checkbox-active-border-color);
                border-radius: 50%;
            }
        }
    }

    > .ui-checkbox-control {
        border-radius: 50%;

        .ui-checkbox-icon {
            display: none;
        }
    }
}

// 可选中按钮
:deep(.selected-buttons) {
    .ui-button {
        --uioption-button-color: #fcfcfc;
        --uioption-button-font-color: var(--uicolor-font-1);
        --uioption-button-disabled-color: #fcfcfc;
        margin: 0 16px 0 0;

        &.ui-disabled-status {
            --uioption-button-font-color: #c5c5c5;
        }

        &:not(.ui-disabled-status) {
            .ui-button-main {
                &:hover,
                &:focus {
                    --uioption-button-font-color: #ffffff;
                }
            }
        }

        &.active {
            .ui-button-main {
                --uioption-button-color: var(--uioption-button-active-color);
                --uioption-button-font-color: #ffffff;
            }
        }
    }

    .model-button:last-child {
        margin: 0;
    }
}

:deep(.pr-suspended-ui) {
    top: 0;
    left: 0;
    border: 1px solid hsla(0, 0%, 89%, 0.3);
    z-index: -1;
    padding: 20px 64px 20px 24px;
    opacity: 0;
    position: fixed;
    visibility: hidden;
    -webkit-transition: opacity 0.2s, visibility 0.2s, -webkit-transform 0.4s;
    transition: opacity 0.2s, visibility 0.2s, -webkit-transform 0.4s;
    transition: opacity 0.2s, transform 0.4s, visibility 0.2s;
    transition: opacity 0.2s, transform 0.4s, visibility 0.2s, -webkit-transform 0.4s;
    background: #fff;
    box-shadow: 0 4px 8px 0 rgba(105, 1, 98, 0.1);
    border-radius: 4px;
}
</style>
